import styled from "styled-components";

export const Sidebar = styled.div`
  width: 250px;
  padding: 20px;


  h2 {
    color: white;


  }

  @media (max-width: 550px) {
    /* Phones */
    width: 100%;
    display: none;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    width: 100%;
    display: none;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 20px;
  max-height: 22em;
  ${props => props.brand === 'tegor' ? 'overflow-y: scroll;' : ''}

  @media (max-width: 550px) {
    /* Phones */
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    overflow-y: visible;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0;
    overflow-y: visible;
  }
`;

const getBackground = (brand, category) => {
  const backgrounds = {
    'dr-reckeweg': {
      default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
    },
    'tegor': {
      default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
    },
    'helixor': {
       default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
    },
    'symbio-pharm': {
      default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
    },
    'regenhial': {
      default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
    },
    default: 'linear-gradient(180deg, #282C34 20%, #000001 100%)'
  };

  const brandBackgrounds = backgrounds[brand] || backgrounds.default;
  return category ? (brandBackgrounds[category] || brandBackgrounds.default) : brandBackgrounds.default;
};

export const MenuContainer = styled.div`
  padding: 40px;
  background: ${props => getBackground(props.brand, props.category)};

  @media (max-width: 550px) {
    /* Phones */
    display: none;
    padding: 10px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: none;
    padding: 10px;
  }
`;

export const LogoContainer = styled.div`
  max-height: 150px;
  margin-bottom: 3em;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 70%;
    max-width: 150px;
  }
`;

export const MenuItem = styled.a.attrs(props => ({
  as: props.as || 'a'
}))`
  width: 90%;
  text-decoration: none;
  color: white;
  margin: 10px 0;
  cursor: pointer;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 0;
    height: 1px;
    background-color: white;
    opacity: 0;
    transition: width 0.3s ease-in-out, opacity 0.2s ease-in-out;
  }
  
  &:hover::after {
    width: 100%;
    opacity: 0.7;
  }

  &.active::after {
    width: 100%;
    opacity: 1;
  }

  @media (max-width: 550px) {
    /* Phones */
    margin: 0 20px 0 0;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    margin: 0 20px 0 0;
  }
`;
